import * as actions from "../action.constants";

export const requestEthernetConfig = () => ({
  type: actions.REQUEST_ETHERNET_CONFIG,
});

export const requestEditEthernetConfigurations = (requestPayload, callback) => ({
  type: actions.REQUEST_EDIT_ETHERNET_SAGA,
  requestPayload,
  callback,
});

export const requestPortFwdConfig = () => ({
  type: actions.REQUEST_PORT_FORWARDING_CONFIGURATIONS,
});

export const requestEditPortForwardingConfigurations = (requestPayload, callback) => ({
  type: actions.REQUEST_EDIT_PORT_FORWARDING_SAGA,
  requestPayload,
  callback,
});

export const resetPFConfig = () => ({
  type: actions.REQUEST_RESET_PF_CONFIG,
});

export const requestModbusTcpIp = () => ({
  type: actions.REQUEST_MODBUS_TCP_IP,
});

export const saveModbusTcpIp = (payload) => ({
  type: actions.SAVE_MODBUS_TCP_IP,
  payload,
});

export const requestCellularModem = () => ({
  type: actions.REQUEST_CELLULAR_MODEM,
});

export const saveCellularModem = (payload) => ({
  type: actions.SAVE_CELLULAR_MODEM,
  payload,
});

export const changeEmailTransmissionConfig = (payload) => ({
  type: actions.CHANGE_EMAIL_TRANSMISSION_CONFIG,
  payload,
});

export const requestAquaticGroupProfiles = () => ({
  type: actions.REQUEST_AQUATIC_GROUP_PROFILES,
});

export const addEditAquaticGroupProfile = (data, callback) => ({
  type: actions.ADD_EDIT_AQUATIC_GROUP_PROFILE,
  payload: data,
  callback,
});
